import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { iDataUser } from "../../../interfaces/SuperAdmin/Pages/iDataUser";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";
import { formatFechaWithHour } from "../../../utils/dateFunctions";
import EstadoBadge from "./EstadoBadge";

interface UserRowProps {
  user: iDataUser;
  i: number;
}

export const ProfileRowUser: React.FC<UserRowProps> = ({ user, i }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/asistente/allusers/${user.id_usuario}`);
  };

  const estadoMap: Record<string, "success" | "warning" | "wrong" | "unknown"> =
    {
      Activo: "success",
      Inactivo: "warning",
      Eliminado: "wrong",
    };

  return (
    <StyledTableRow>
      <StyledTableCell sx={{ mb: 2 }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {user.nombres} {user.apellidos}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{user.email}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{user.pais}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{user.version}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        <EstadoBadge estado={estadoMap[user.estado] ?? "unknown"}>
          {user.estado}
        </EstadoBadge>
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {formatFechaWithHour(user.created_at)}
      </StyledTableCell>

      <StyledTableCell
        align="center"
        sx={{ display: "flex", flexDirection: "row" }}
      >
        <Button sx={{ color: "#336B87" }} onClick={handleNavigate}>
          <Tooltip title="Ver usuario">
            <IconButton aria-label="usuarios" sx={{ color: "#336B87" }}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};
